export default __webpack_public_path__ + "static/mockup-frame-5076b98dedacb805f54751fd509a1f9a.png";